import { Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe';
import { debounceTime } from 'rxjs/operators';

@AutoUnsubscribe
@Component({
  selector: 'ex-filter-text',
  templateUrl: './ex-filter-text.component.html',
  styleUrls: ['./ex-filter-text.component.scss'],
})
export class ExFilterTextComponent implements OnInit {
  @Input() placeholder?: string;
  @Input() text?: string;
  @Input() variant: 'regular' | 'light' = 'regular';
  @Input() size: 'regular' | 'compact' = 'regular';
  @Input() debounceMs = 1000;
  @Output() textEnter = new EventEmitter<string>();
  text$ = new BehaviorSubject<string | null>(null);
  isFocused = false;
  listen = false;

  @ContentChild('leftIconTemplate') leftIconTemplate?: TemplateRef<any>;

  ngOnInit(): void {
    this.text$.pipe(debounceTime(this.debounceMs)).subscribe(res => {
      if (res !== null && this.listen) this.emitText();
    });
  }

  onInputFocus() {
    this.isFocused = true;
  }

  onInputBlur() {
    this.isFocused = false;
  }

  clearInput() {
    this.text = '';
    this.emitText();
  }

  emitText() {
    this.text = this.text?.trim();
    this.textEnter.emit(this.text);
    this.listen = false;
  }

  textChanged() {
    this.listen = true;
    this.text$.next(this.text ?? '');
  }
}
